import { render, staticRenderFns } from "./ShopMerchant.vue?vue&type=template&id=0aab04fe&scoped=true&"
import script from "./ShopMerchant.vue?vue&type=script&lang=js&"
export * from "./ShopMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ShopMerchant.vue?vue&type=style&index=0&id=0aab04fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab04fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VList,VRow})
